import styled from 'styled-components';

import Section from 'components/structure/Section';

export const StyledSection = styled(Section)`
  background-position-y: top;
  min-height: 520px;
  align-items: flex-start;
`;

StyledSection.displayName = 'StyledSection';
